import {PRODUCTION} from "../constants/environment"
import {selectedEnvironment} from "../config"
export const SHOPDM_DELIVERY_ID = selectedEnvironment === PRODUCTION ? 'FUmBijiPTuGVKNLOM7Wl' : 'GlarWVNG3jFW2lEMczWH'
